<template>
  <assistant-step>
    <div v-if="sentSuccessfully">
      <gc-row>
        <gc-col cols="12">
          <h2 class="gc-text-primary gc-text-2xl gc-text-center">
            {{ $t('sentSuccessfully.title') }}
          </h2>
        </gc-col>
      </gc-row>
      <gc-row>
        <gc-col cols="12">
          <p class="gc-text-center">{{ $t('sentSuccessfully.text') }}</p>
        </gc-col>
      </gc-row>
    </div>
    <div v-else>
      <gc-form v-model="formValid" @submit.prevent="onNext()">
        <gc-row>
          <gc-col cols="12">
            <h3
              class="gc-font-bold gc-text-xl gc-mt-0 gc-mb-0 gc-text-dark gc-text-center gc-font-weight-bold"
            >
              {{ $t(`${step.id}.title`) }}
            </h3>
          </gc-col>
        </gc-row>
        <gc-row>
          <gc-col cols="12">
            <p class="gc-text-center">
              {{ $t(`${step.id}.${categoryId}.subtitle`) }}
            </p>
          </gc-col>
        </gc-row>
        <gc-row>
          <gc-col cols="12">
            <form-field
              :form-data="formData"
              field-name="salutation"
              :step="step"
            ></form-field>
          </gc-col>
        </gc-row>
        <gc-row>
          <gc-col cols="12" sm="6">
            <form-field
              :form-data="formData"
              field-name="firstname"
              :step="step"
            ></form-field>
          </gc-col>
          <gc-col cols="12" sm="6">
            <form-field
              :form-data="formData"
              field-name="lastname"
              :step="step"
            ></form-field>
          </gc-col>
        </gc-row>
        <gc-row>
          <gc-col cols="12" sm="6">
            <form-field
              :form-data="formData"
              field-name="zipcode"
              :step="step"
            ></form-field>
          </gc-col>
          <gc-col cols="12" sm="6">
            <form-field
              :form-data="formData"
              field-name="city"
              :step="step"
            ></form-field>
          </gc-col>
        </gc-row>
        <gc-row>
          <gc-col cols="12" sm="6">
            <form-field
              :form-data="formData"
              field-name="street"
              :step="step"
            ></form-field>
          </gc-col>
          <gc-col cols="12" sm="6">
            <form-field
              :form-data="formData"
              field-name="streetNumber"
              :step="step"
            ></form-field>
          </gc-col>
        </gc-row>
        <gc-row>
          <gc-col cols="12" sm="6">
            <form-field
              :form-data="formData"
              field-name="phone"
              :step="step"
            ></form-field>
          </gc-col>

          <gc-col cols="12" sm="6">
            <form-field
              :form-data="formData"
              field-name="email"
              :step="step"
            ></form-field>
          </gc-col>
        </gc-row>
        <gc-row v-if="categoryId === StepCategoryId.SOLAR">
          <gc-col>
            <form-field
              :form-data="formData"
              field-name="invoiceAddressDiffers"
              :step="step"
              :assistantContext="assistantContext"
            ></form-field>
          </gc-col>
        </gc-row>
        <gc-row
          v-if="
            assistantContext.assistantSubmit.invoiceAddressDiffers.includes(
              'yes',
            )
          "
        >
          <gc-col>
            <label class="gc-block gc-text-sm gc-relative">{{
              $t(`${step.id}.formFields.invoiceAddressLabel.label`)
            }}</label>
          </gc-col>
        </gc-row>
        <gc-row
          v-if="
            assistantContext.assistantSubmit.invoiceAddressDiffers.includes(
              'yes',
            )
          "
        >
          <gc-col cols="12" sm="9">
            <form-field
              :form-data="formData"
              field-name="invoiceAddressStreet"
              :step="step"
            ></form-field>
          </gc-col>
          <gc-col cols="12" sm="3">
            <form-field
              :form-data="formData"
              field-name="invoiceAddressStreetNumber"
              :step="step"
            ></form-field>
          </gc-col>
        </gc-row>
        <gc-row
          v-if="
            assistantContext.assistantSubmit.invoiceAddressDiffers.includes(
              'yes',
            )
          "
        >
          <gc-col cols="12" sm="4">
            <form-field
              :form-data="formData"
              field-name="invoiceAddressZipcode"
              :step="step"
            ></form-field>
          </gc-col>
          <gc-col cols="12" sm="8">
            <form-field
              :form-data="formData"
              field-name="invoiceAddressCity"
              :step="step"
            ></form-field>
          </gc-col>
        </gc-row>
        <gc-row>
          <gc-col cols="12">
            <form-field
              :form-data="formData"
              field-name="note"
              :step="step"
            ></form-field>
          </gc-col>
        </gc-row>
        <gc-row v-if="prevPage === StepId.EMOBILITY_INTEREST">
          <gc-col cols="12">
            <form-field
              :form-data="formData"
              field-name="buildingType"
              :step="step"
            ></form-field>
          </gc-col>
        </gc-row>
        <gc-row v-if="categoryId === StepCategoryId.SOLAR">
          <gc-col cols="12">
            <form-field
              :form-data="formData"
              field-name="buildingTypeSingleOrFamily"
              :step="step"
            ></form-field>
          </gc-col>
        </gc-row>
        <gc-row v-if="categoryId === StepCategoryId.SOLAR">
          <gc-col cols="12">
            <form-field
              :form-data="formData"
              field-name="owner"
              :step="step"
            ></form-field>
          </gc-col>
        </gc-row>
        <gc-row v-if="categoryId === StepCategoryId.SOLAR">
          <gc-col cols="12">
            <form-field
              :form-data="formData"
              field-name="usage"
              :step="step"
            ></form-field>
          </gc-col>
        </gc-row>
        <gc-row v-if="categoryId === StepCategoryId.SOLAR">
          <gc-col cols="12">
            <form-field
              :form-data="formData"
              field-name="solarRoofShape"
              :step="step"
            ></form-field>
          </gc-col>
        </gc-row>
        <gc-row>
          <gc-col cols="12">
            <form-field
              :form-data="formData"
              field-name="referral"
              :step="step"
            ></form-field>
          </gc-col>
        </gc-row>
        <gc-row v-if="categoryId === StepCategoryId.SOLAR">
          <gc-col cols="12">
            <form-field
              :form-data="formData"
              field-name="consentContact"
              :step="step"
            ></form-field>
          </gc-col>
        </gc-row>

        <gc-row>
          <gc-col cols="12">
            <assistant-step-navigation
              :assistantContext="assistantContext"
              :step="step"
              :steps="steps"
              :submit="step.submit"
              :valid="formValid"
              @prev="onPrev()"
              @next="onSend()"
            />
          </gc-col>
        </gc-row>

        <gc-row>
          <gc-col cols="12">
            <div
              class="gc-text-sm gc-text-center gc-text-gray-400"
              v-if="showRequiredHint"
            >
              <span class="gc-text-primary">*</span> {{ $t('requiredHint') }}
            </div>
            <div class="gc-text-sm gc-mt-8 gc-text-center gc-text-gray-400">
              <span v-html="$t('privacy')" class="privacyText"></span>
            </div>
          </gc-col>
        </gc-row>
      </gc-form>
    </div>
  </assistant-step>
</template>

<script lang="ts">
import {
  computed,
  defineComponent,
  onMounted,
  ref,
  watch,
} from '@vue/composition-api';
import AssistantStep from '@/components/AssistantStep.vue';
import GcForm from '@/components/primitives/GcForm.vue';
import AssistantStepNavigation from '@/components/AssistantStepNavigation.vue';
import { getStepContext } from '@/lib/context';
import { stepComponentProps } from '@/lib/steps/helper';
import FormField from '@/components/FormField.vue';
import { useBaseTransitions } from '@/lib/xstate/transitions';
import GcCol from '@/components/primitives/GcCol.vue';
import GcRow from '@/components/primitives/GcRow.vue';
import AssistantHeader from '~/components/AssistantHeader.vue';
import { AssistantContext } from '~/steps/steps';
import { StepCategoryId, StepId } from '~/consts/assistant-steps';
import { EventBus } from '@/main';
import { saveStateToLocalStorage } from '@/lib/storage/local-storage';
import { sendEvent } from '@/lib/analytics/dataLayer';

export default defineComponent({
  components: {
    AssistantStep,
    AssistantStepNavigation,
    FormField,
    GcCol,
    GcForm,
    GcRow,
    AssistantHeader,
  },
  emits: ['transition', 'reset-data'],
  props: {
    ...stepComponentProps,
  },
  setup: (props, { emit }) => {
    onMounted(() => {
      /**
       *  Google Tag Manager push dataLayer
       */

      const categoryId = assistant.getAttribute(
        'data-category',
      ) as StepCategoryId;
      const interestValue = props.assistantContext.emobilityInterest.interest;
      const isEmobilityCheckOpened =
        categoryId === StepCategoryId.EMOBILITY &&
        !interestValue.includes('buy');
      if (isEmobilityCheckOpened) {
        sendEvent({ eventName: 'shop_assistant_open_installationscheck' });
      }
    });

    const { onNext } = useBaseTransitions(
      emit,
      props.assistantContext,
      props.step,
    );

    const useLocalStorage = process.env.VUE_APP_USE_LOCALSTORAGE === 'true';
    const formData = getStepContext(props.assistantContext, props.step);
    const formValid = ref(false);
    const sentSuccessfully = ref(false);
    const interestValue = props.assistantContext.emobilityInterest.interest;
    const showRequiredHint = computed<boolean>(
      (): boolean =>
        process.env.VUE_APP_SHOW_REQUIRED_HINT === 'true' &&
        Boolean(
          props.step?.fields &&
            props.step?.fields.some((field) => field.required === true),
        ),
    );

    const assistant = document.querySelector(
      '.sidebar header ul > li.active',
    ) as HTMLLIElement;

    const categoryId = computed(
      () => assistant.getAttribute('data-category') as StepCategoryId,
    );

    const prevPage = computed(() => {
      if (categoryId.value === StepCategoryId.EMOBILITY) {
        return interestValue.includes('buy')
          ? StepId.EMOBILITY_BUY
          : StepId.EMOBILITY_INTEREST;
      }

      return (
        [...(props.steps ?? [])]
          .filter((s) => s.categoryId === categoryId.value)
          .reverse()
          .find((s) => !s.isDisabled?.(props.assistantContext))?.id ?? null
      );
    });

    if (useLocalStorage) {
      saveStateToLocalStorage(
        props.assistantContext,
        props.step ? props.step.id : '',
        categoryId.value,
      );

      watch(props.assistantContext, (value: AssistantContext) => {
        saveStateToLocalStorage(
          value,
          props.step ? props.step.id : '',
          categoryId.value,
        );
      });
    }

    const onPrev = () => {
      emit('transition', {
        event: 'BACK_TO_' + prevPage.value?.toUpperCase(),
      });
    };

    const onSend = () => {
      sentSuccessfully.value = true;
      EventBus.$emit('reset-data');
    };

    let headerTitle = '';

    if (categoryId.value === StepCategoryId.EMOBILITY) {
      headerTitle =
        prevPage.value === StepId.EMOBILITY_BUY
          ? 'emobilityBuy.title'
          : 'emobilityCheck.title';
    }

    return {
      formData,
      formValid,
      StepId,
      prevPage,
      onPrev,
      onNext,
      onSend,
      showRequiredHint,
      sentSuccessfully,
      headerTitle,
      categoryId,
      StepCategoryId,
    };
  },
});
</script>
